if (!customElements.get('product-media-gallery')) {
    class ProductMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.mode = null;
        this.slides = [];
        this.subscriptionFilterEnabled = this.dataset.subscriptionFilterEnabled === 'true';
        this.isSubscriptionSelected = false;
        this.desktopMQ = window.matchMedia('(min-width: 750px)');
        this.isDesktopCached = this.desktopMQ.matches;
        this.onMediaQueryChange = (e) => {
          this.isDesktopCached = e.matches;
          this.updateMode();
        };
        this.mediaUpdated = this.mediaUpdated.bind(this);
        this.onSkioUpdateSellingPlan = this.onSkioUpdateSellingPlan.bind(this);
      }
  
      connectedCallback() {
        this.container = this.querySelector('.product-media-gallery-wrapper');
        if (!this.container) return;
  
        this.sectionId = this.closest('product-info')?.dataset?.section || null;
        this.fancyboxGroup = this.sectionId ? `gallery-${this.sectionId}` : 'gallery';
  
        this.refreshSlides();
        this.updateMode(true);
  
        this.desktopMQ.addEventListener('change', this.onMediaQueryChange);
        document.addEventListener('update:media', this.mediaUpdated);
  
        if (this.subscriptionFilterEnabled) {
            this.syncSubscriptionFromDom();
          document.addEventListener('skio::update-selling-plan', this.onSkioUpdateSellingPlan);
        }
  
        this.dispatchMediaUpdatedEvent();
        this.refreshFancyboxVisibleOnly();
      }
  
      disconnectedCallback() {
        this.desktopMQ.removeEventListener('change', this.onMediaQueryChange);
        document.removeEventListener('update:media', this.mediaUpdated);
        document.removeEventListener('skio::update-selling-plan', this.onSkioUpdateSellingPlan);
        this.destroySwiper();
      }
  
      isDesktop() {
        return this.isDesktopCached;
      }
  
      refreshSlides() {
        this.slides = Array.from(this.querySelectorAll('.product-media-gallery-item'));
        this.thumbnailSlides = Array.from(this.querySelectorAll('.product-media-gallery-thumbnail-item'));
      }
  
        mediaUpdated() {
            this.refreshSlides();
            
            if (this.mode === 'swiper') {
                this.reInitSwiper();
            } else {
                this.updateMode();
            }
            
            this.dispatchMediaUpdatedEvent();
            this.refreshFancyboxVisibleOnly();
        }          
  
      getCurrentVisibleSlide() {
        return (
          this.querySelector('.product-media-gallery-item.swiper-slide-active:not(.hidden)') ||
          this.querySelector('.product-media-gallery-item:not(.hidden)')
        );
      }
  
      dispatchMediaUpdatedEvent() {
        const firstSlide = this.getCurrentVisibleSlide();
        if (!firstSlide) return;
  
        document.dispatchEvent(
          new CustomEvent('product-media::updated', {
            detail: { firstSlide, sectionId: this.sectionId },
          })
        );
      }
  
      syncSubscriptionFromDom() {
        if (!this.subscriptionFilterEnabled) return;
        requestAnimationFrame(() => {
            const scope = this.closest('product-info') || document;
            const input = scope?.querySelector('input.selected-selling-plan-id[name="selling_plan"]');
            this.isSubscriptionSelected = Boolean(input?.value);
            this.filterMediaGallery();
        });
      }
  
      onSkioUpdateSellingPlan(e) {
        if (!this.subscriptionFilterEnabled) return;
        const source = e.target?.closest?.('product-info');
        const mine = this.closest('product-info');
        if (source && mine && source !== mine) return;

        const next = Boolean(e.detail?.sellingPlan?.id);
        if (next === this.isSubscriptionSelected) return;

        this.isSubscriptionSelected = next;
        this.filterMediaGallery();
      }
  
      filterMediaGallery() {
        const type = this.isSubscriptionSelected ? 'subscription' : 'normal';
  
        this.slides.forEach((slide) => {
          const show = slide.dataset.imageType === type;
          slide.classList.toggle('hidden', !show);
          slide.classList.toggle('swiper-slide', show);
        });

        if (this.thumbnailSlides) {
          this.thumbnailSlides.forEach((slide) => {
            const show = slide.dataset.imageType === type;
            slide.classList.toggle('hidden', !show);
            slide.classList.toggle('swiper-slide', show);
          });
        }
  
        if (this.mode === 'swiper') this.reInitSwiper();
        this.dispatchMediaUpdatedEvent();
        this.refreshFancyboxVisibleOnly();
      }
  
      refreshFancyboxVisibleOnly() {
        this.slides.forEach((slide) => {
          const link = slide.querySelector('a[href]');
          if (!link) return;
  
          if (slide.classList.contains('hidden')) {
            link.removeAttribute('data-fancybox');
          } else {
            link.setAttribute('data-fancybox', this.fancyboxGroup);
          }
        });
      }
  
      updateMode(isInitial = false) {
        const desktopLayout = this.dataset.desktopLayout || 'grid';
        const nextMode = (this.isDesktop() && desktopLayout === 'grid') ? 'grid' : 'swiper';
        if (!isInitial && nextMode === this.mode) return;
  
        this.mode = nextMode;
        this.setAttribute('data-mode', nextMode);
        nextMode === 'swiper' ? this.waitForSwiperAndLayout() : this.destroySwiper();
      }
  
      waitForSwiperAndLayout() {
        const check = () => {
          if (!window.Swiper || !this.container?.offsetWidth) {
            requestAnimationFrame(check);
            return;
          }
          this.initSwiper();
        };
        requestAnimationFrame(check);
      }
  
      initSwiper() {
        if (this.swiper) return;
        this.pagination = this.container.querySelector('.swiper-pagination') || null;
        
        const showThumbnailsDesktop = this.dataset.showThumbnailsDesktop === 'true';
        const showThumbnailsMobile = this.dataset.showThumbnailsMobile === 'true';
        
        const shouldShowThumbnails = (this.isDesktop() && showThumbnailsDesktop) || (!this.isDesktop() && showThumbnailsMobile);
        
        this.thumbnailsContainer = this.querySelector('.product-media-thumbnails-wrapper');
        
        if (shouldShowThumbnails && this.thumbnailsContainer) {
          this.thumbnailsContainer.style.display = 'block';
          this.thumbnailSwiper = new Swiper(this.thumbnailsContainer, {
            slidesPerView: 4,
            spaceBetween: 12,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
          });
        } else if (this.thumbnailsContainer) {
          this.thumbnailsContainer.style.display = 'none';
        }

        const showMainArrows = this.dataset.showMainArrows === 'true';
        const mainPrev = this.container.querySelector('.product-media-gallery__arrow--prev');
        const mainNext = this.container.querySelector('.product-media-gallery__arrow--next');
        const mainNav = showMainArrows && mainPrev && mainNext ? { prevEl: mainPrev, nextEl: mainNext } : null;

        this.swiper = new Swiper(this.container, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          freeMode: false,
          loop: true,
          spaceBetween: 10,
          slidesOffsetAfter: 0,
          breakpoints: {
            768: {
              slidesOffsetAfter: 0,
            },
            1024: {
              slidesOffsetAfter: 0,
            },
          },
          watchOverflow: true,
          observer: true,
          observeParents: true,
          ...(this.pagination ? { pagination: { el: this.pagination, clickable: true } } : {}),
          ...(mainNav ? { navigation: mainNav } : {}),
          ...(this.thumbnailSwiper ? { thumbs: { swiper: this.thumbnailSwiper } } : {}),
        });
  
        this.swiper.update();
        this.dispatchMediaUpdatedEvent();
      }
  
      reInitSwiper() {
        this.destroySwiper();
        requestAnimationFrame(() => this.initSwiper());
      }
  
      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, false);
          this.swiper = null;
        }
        if (this.thumbnailSwiper) {
          this.thumbnailSwiper.destroy(true, false);
          this.thumbnailSwiper = null;
        }
      }
    }
  
    customElements.define('product-media-gallery', ProductMediaGallery);
  }  